export default {
  greeting: 'Bonjour',
  description: 'Description',
  price_range: 'Budget',
  quoteStatus: 'Statut',
  status: 'Statut',
  date: 'Date',
  alliances: 'Alliances',
  quotes: 'Soumission',
  published_at: 'Date de publication',
  priority: {
    urgent: 'Urgent',
    featured: 'En vedette',
  },
  job_listing_types: {
    urgent: 'Urgent',
    featured: 'En vedette',
  },
  not_published: 'Non publié',
  show_details: 'Afficher les détails',
  previous: 'Précédent',
  next: 'Suivant',
  wallet: {
    title: 'Mon Porte-monnaie',
    credits: 'Mes crédits',
    manage: 'Gérer',
    latestExpenses: 'Dernières dépenses',
  },
  organizationReview: {
    title: 'Votre organisation est en cours de validation',
    description:
      "Nous vérifions actuellement l'éligibilité de votre organisation à notre programme de crédits gratuits pour les organisations à but non lucratif. Vous pouvez utiliser votre compte normalement pendant la validation.",
  },
  notifications: {
    title: 'Notifications',
    descriptions: 'Description',
    view_all: 'Voir toutes mes notifications',
    view_detail: 'Voir le détail',
  },
  submissions: {
    title: 'Mes soumissions',
    view_all: 'Voir toutes mes soumissions',
    status: {
      submitted: 'Soumis',
      pending: 'En attente',
      accepted: 'Accepté',
      rejected: 'Rejeté',
    },
  },
  jobs: {
    title: 'Mes projets',
    view_all: 'Voir tous mes projets',
    status: {
      draft: 'Brouillon',
      published: 'Publié',
      closed: 'Fermé',
    },
  },
  projects: {
    title: 'Mes projets en cours',
    view_all: 'Voir tous mes projets',
  },
  recent_projects: 'Mes projets en cours',
  view_all_projects: 'Voir tous mes projets',
  my_contacts: 'Mes contacts',
  my_prospects: 'Mes prospects',
  view: 'Voir',
  to: 'à',
};
